import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';

export const SideMenuContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  background: ${styleSheet.bgDark};
  height: 100%;
  width: 11rem;
`;

export const SideMenuList = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const SideMenuListItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  cursor: pointer;
  list-style: none;
  margin: 3rem 0;
`;

export const MenuListText = styled.span`
  color: ${styleSheet.shapeDark};
  font-size: 1.5rem;
  margin-top: 1rem;
`;

export const MainLogo = styled.img`
  width: 5rem;

  margin-top: 3rem;
`;

export const VersionContainer = styled.div`
  text-align: center;
  position: absolute;
  bottom: 5px;
  width: 100%;
`;

export const VersionText = styled.span`
  font-size: 1.4rem;
  color: #fff;
`;